module.exports = __webpack_public_path__ + "img/ar-view.3653823.jpg";